/* eslint-disable eqeqeq */
import { useState } from "react";
import { CheckIcon, CaretSortIcon, Cross2Icon } from "@radix-ui/react-icons";

import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";

export default function Combobox({
  options = [],
  value,
  onChange,
  placeholder = "Select option",
  disabled,
  isClearable = false,
  onClear,
}) {
  const [open, setOpen] = useState(false);

  const selected = options.find((o) => o.value == value);

  const handleClear = (e) => {
    e.stopPropagation();

    if (onClear) {
      onClear();
    } else {
      onChange?.(null);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn(
            "w-full justify-between h-9 px-3",
            !value && "text-muted-foreground",
          )}
          disabled={disabled}
        >
          <span className="truncate">
            {selected ? selected.label : placeholder}
          </span>

          <div className="ml-2 flex items-center gap-1">
            {isClearable && value ? (
              <Cross2Icon
                className="h-4 w-4 opacity-70 hover:opacity-100"
                onClick={handleClear}
              />
            ) : (
              <CaretSortIcon className="h-4 w-4 shrink-0 opacity-50" />
            )}
          </div>
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-full p-0">
        <Command>
          <CommandInput placeholder="Search..." className="h-9" />

          <CommandList>
            <CommandEmpty>No option found.</CommandEmpty>

            <CommandGroup>
              {options.map((item) => (
                <CommandItem
                  key={item.value}
                  value={item.label}
                  onSelect={() => {
                    onChange(item.value);
                    setOpen(false);
                  }}
                >
                  {item.label}

                  <CheckIcon
                    className={cn(
                      "ml-auto h-4 w-4",
                      value == item.value ? "opacity-100" : "opacity-0",
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
